export default function(form, name, classes = [], data = {}) {
	data.component = 'form';
	data.form = name;
	data.fieldsGroup = name;
	return `<form ${this.html.classAttr(['form'].concat(classes))} ${this.html.dataAttr(data)}>`;
}
